const baseURL = 'https://superofertas.store/';

export default baseURL;
